<template>
  <vx-modal
    :title="
      !form.uuid ? $t('messages.create.title') : $t('messages.edit.title')
    "
    :active.sync="show"
  >
    <form @submit.prevent="save" @keydown="form.onKeydown($event)">
      <div class="sm:w-12/12">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <vs-input
              :label="$t('products.labels.name')"
              name="price"
              class="w-full"
              v-model="form.name"
              disabled
            />
          </div>
        </div>
      </div>
      <div class="sm:w-12/12">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <vs-input
              :label="$t('products.labels.price')"
              name="price"
              class="w-full"
              v-model="form.price"
            />
            <has-error :form="form" field="price" />
          </div>
        </div>
      </div>
      
      <div class="flex flex-wrap justify-between">
        <div class="mb-6 md:mb-0 mr-4"></div>

        <div class="mb-6 flex flex-wrap justify-between">
          <vs-button class="md:mb-0" v-if="!form.uuid" button="submit">
            {{ $t('messages.create.title') }}
          </vs-button>
          <vs-button class="md:mb-0" v-else button="submit">
            {{ $t('messages.edit.title') }}
          </vs-button>
        </div>
      </div>
    </form>
  </vx-modal>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import Form from 'vform'

export default {
  data() {
    return {
      form: new Form({
        uuid: null,
        price: null
      }),
      disableButton: false,
      show: false
    }
  },
  watch: {
    show(value) {
      if (!value) {
        this.clearForm()
      }
    }
  },
  methods: {
    showModal() {
      this.show = true
    },
    save() {
      if (this.form.uuid) {
        this.edit()
      }
    },
    async edit() {
      let message_title = null
      let message_content = null
      let message_type = null
      const vm = this
      try {
        this.disableButton = true
        vm.$vs.loading()
        const { data } = await this.form.patch(
          `${process.env.VUE_APP_API_URL}/api/products/${this.form.uuid}`
        )

        this.$parent.getProducts()
        this.$vs.loading.close()
        this.form = Object.assign(this.form, data)
        message_type = 'success'
        message_content = this.$t('messages.edit.messages.success_description')
        message_title = this.$t('messages.edit.messages.success')
        this.showMessage(message_type, message_title, message_content)

        this.show = false
        this.clearForm()
      } catch (exception) {
        this.$vs.loading.close()
        console.log('Ocurrió un error:', exception)
      }
      this.disableButton = false
    },
    async getProduct(uuid) {
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_URL}/api/products/${uuid}`
        )
        this.form = _.assign(this.form, data)
      } catch (error) {
        console.log('Ocurrió un error:', error)
      }
    },
    showMessage(message_type, message_title, message_content) {
      Swal.fire({
        icon: message_type,
        title: message_title,
        text: message_content,
        confirmButtonText: this.$t('ok')
      })
    },
    clearForm() {
      this.form = _.assign(this.form, {
          uuid : null,
          price: null
      })
      this.form.clear()
    }
  }
}
</script>
